import React from "react";
import { useTranslation } from "react-i18next";
import SidebarDropdown from "./SidebarDropdown";
import SidebarItem from "./SidebarItem";
const SidebarItems = ({ menuEntries, currentServiceId, customMenuForCurrentService, linkComponent, }) => {
    const { t } = useTranslation("sidebar");
    const nestedItems = menuEntries.map(({ serviceId, serviceLink, icon, label }) => {
        const isCurrentService = serviceId === currentServiceId;
        if (isCurrentService && customMenuForCurrentService !== undefined) {
            return (React.createElement(SidebarDropdown, { key: serviceId, active: true, label: t(label), icon: icon, "data-testid": `sidebar-item-${label}`, linkComponent: linkComponent }, customMenuForCurrentService));
        }
        else {
            return (React.createElement(SidebarItem, { key: serviceId, label: t(label), to: serviceLink, icon: icon, selected: isCurrentService, "data-testid": `sidebar-item-${label}`, linkComponent: linkComponent }));
        }
    });
    return React.createElement(React.Fragment, null, nestedItems);
};
export default SidebarItems;
//# sourceMappingURL=SidebarItems.js.map